import {ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FlexLayoutModule} from '@angular/flex-layout';
import {TranslateModule} from '@ngx-translate/core';
import {LoggedInGuard} from './guards/logged-in.guard';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatIconModule} from '@angular/material/icon';
import {HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {TokenService} from './providers/token.service';
import {AuthService} from './providers/auth.service';
import {UserService} from './providers/user.service';
import {RolePipe} from './pipes/role.pipe';
import {TimestampPipe} from './pipes/timestamp.pipe';
import {ClientService} from './providers/client.service';
import {ErrorService} from './providers/error.service';
import {NotificationService} from './providers/notification.service';
import {NgxPermissionsModule} from 'ngx-permissions';
import {FatalErrorDialogComponent} from './components/fatal-error-dialog/fatal-error-dialog.component';
import {NgxsModule} from '@ngxs/store';
import {TaskStatePipe} from './pipes/task-state.pipe';
import {BoolVisualizerComponent} from './components/bool-visualizer/bool-visualizer.component';
import {ProgressButtonComponent} from './components/progress-button/progress-button.component';
import {environment} from '../../environments/environment';
import {FileUploadService} from './providers/file-upload.service';
import {LogService} from './providers/log.service';
import {RequestDefinitionService} from './providers/request-definition.service';
import {TaskService} from './providers/task.service';
import {TransferErrorService} from './providers/transfer-error.service';
import {UserAdminService} from './providers/user-admin.service';
import {ClientSelectorComponent} from './components/client-selector/client-selector.component';
import {CodeEditorComponent} from './components/code-editor/code-editor.component';
import {FileInputComponent} from './components/file-input/file-input.component';
import {FileUploadComponent} from './components/file-upload/file-upload.component';
import {RequestDefinitionSelectorComponent} from './components/request-definition-selector/request-definition-selector.component';
import {FormsModule} from '@angular/forms';
import {JwtAuthInterceptor} from './interceptors/jwt-auth-interceptor';
import {LoadingInterceptor} from './interceptors/loading-interceptor';
import {ErrorInterceptor} from './interceptors/error-interceptor';
import {DescriptionDialogComponent} from './components/description-dialog/description-dialog.component';
import {StatePipe} from './pipes/state-pipe';
import {MomentModule} from 'ngx-moment';
import {MatMomentDateModule, MomentDateAdapter} from '@angular/material-moment-adapter';
import {SimpleErrorDialogComponent} from './components/simple-error-dialog/simple-error-dialog.component';
import {SubtaskPipe} from './pipes/subtask.pipe';
import {SortPipe} from './pipes/sort.pipe';
import {WorkflowPipe} from './pipes/workflow.pipe';
import {QueueTaskTimePipe} from './pipes/queueTask-time.pipe';
import {AutoLogoutService} from './providers/auto-logout.service';
import {MatButtonModule} from '@angular/material/button';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatSelectModule} from '@angular/material/select';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatListModule} from '@angular/material/list';
import {MatTabsModule} from '@angular/material/tabs';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatDialogModule} from '@angular/material/dialog';
import {AceModule} from 'ngx-ace-wrapper';

@NgModule({
  declarations: [
    RolePipe,
    TimestampPipe,
    TaskStatePipe,
    SubtaskPipe,
    BoolVisualizerComponent,
    ClientSelectorComponent,
    CodeEditorComponent,
    FatalErrorDialogComponent,
    FileInputComponent,
    FileUploadComponent,
    ProgressButtonComponent,
    RequestDefinitionSelectorComponent,
    DescriptionDialogComponent,
    StatePipe,
    QueueTaskTimePipe,
    SimpleErrorDialogComponent,
    SortPipe,
    WorkflowPipe,
  ],
  exports: [
    NgxsModule,
    FlexLayoutModule,
    TranslateModule,
    NgxPermissionsModule,
    MatSnackBarModule,
    MatDialogModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatTooltipModule,
    MatButtonModule,
    RolePipe,
    TimestampPipe,
    TaskStatePipe,
    SubtaskPipe,
    StatePipe,
    QueueTaskTimePipe,
    BoolVisualizerComponent,
    ClientSelectorComponent,
    CodeEditorComponent,
    FatalErrorDialogComponent,
    FileInputComponent,
    FileUploadComponent,
    ProgressButtonComponent,
    RequestDefinitionSelectorComponent,
    MomentModule,
    MatDatepickerModule,
    MatMomentDateModule,
    MatListModule,
    MatTabsModule,
    WorkflowPipe
  ],
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    AceModule,
    MatIconModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatFormFieldModule,
    MatInputModule,
    MatTooltipModule,
    MatListModule,
    MatTabsModule
  ],
  providers: [
    {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
    {provide: MAT_DATE_FORMATS, useValue: environment.datePickerFormat},
    {provide: MAT_DATE_LOCALE, useValue: environment.datePickerLocale},
  ]
})
export class SharedModule {

  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [
        TokenService,
        AuthService,
        ClientService,
        ErrorService,
        FileUploadService,
        LogService,
        NotificationService,
        RequestDefinitionService,
        TaskService,
        TokenService,
        TransferErrorService,
        UserService,
        UserAdminService,
        LoggedInGuard,
        AutoLogoutService,
        /*        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
                { provide: MAT_DATE_FORMATS, useValue: environment.datePickerFormat },
                { provide: MAT_DATE_LOCALE, useValue: environment.datePickerLocale },*/
        {provide: HTTP_INTERCEPTORS, useClass: JwtAuthInterceptor, multi: true},
        {provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true},
        {provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true},
        provideHttpClient(withInterceptorsFromDi()),
      ]
    };
  }

}
